/**
 * Explanation under the "Publiek document" checkbox of both upload field types (`upload` and
 * `upload-document-entry`). Shown when the field's `publicDocumentHint` prop is empty or absent;
 * a non-empty prop replaces it. User-facing, hence Dutch.
 *
 * The private half names no permission on purpose: the API opens a private file for module read
 * rights, for an auth-group right, for the onboarding role and for a system administrator, and for
 * `upload-document-entry` the file lives in the Documents module rather than in the form's own
 * module. "Toegang tot dit document" is what every one of those has in common; a tenant that wants
 * the exact rule writes it in `publicDocumentHint`.
 */
export const DEFAULT_PUBLIC_DOCUMENT_HINT =
  'Publiek: het bestand is via een directe link te openen, ook zonder inloggen. Privé: alleen te openen door ingelogde gebruikers met toegang tot dit document.';

/** The configured `publicDocumentHint`, or the default when it is empty, blank or not a string. */
export function resolvePublicDocumentHint(configured: unknown): string {
  return typeof configured === 'string' && configured.trim() ? configured.trim() : DEFAULT_PUBLIC_DOCUMENT_HINT;
}

/** Shared by every upload field instance on the page, so ids never collide across the two types. */
let hintIdCounter = 0;

/**
 * A fresh id for the hint under the checkbox, which the checkbox references with aria-describedby.
 * The prefix names the field type; the counter keeps two fields of the same type apart.
 */
export function nextPublicDocumentHintId(prefix: string): string {
  return `${prefix}-${hintIdCounter++}`;
}
